import { useTranslation } from 'react-i18next';

/**
 * The word a screen reader hears after a flagged lab value, so a reading conveyed visually by the
 * destructive color is not read out exactly like a normal one. Rendered only when the value is flagged.
 */
export const AbnormalFlagLabel = (): React.ReactElement => {
  const { t } = useTranslation('records');
  return <span className="sr-only">, {t('abnormal')}</span>;
};
